import { Link } from '@mui/material';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import { setPath } from 'src/store/Navigation';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import DeligationOfAuth from './DeligationOfAuth';
import DrugAccountability from './Drug Accountability/DrugAccountability';
import Form1572 from './Form1572/1572';
import VersionHistory from './Form1572/VersionHistory';
import Issues from './IssueLog/Issues';
import ProtocolDeviations from './ProtocolDeviationslLog/ProtocolDeviations';
import ProtocolQA from './ProtocolQ&ALog/ProtocolQA';
import './StudyLogs.scss';
import './studylogStyles.scss';
import TrainingLog from './TrainingLogs/TrainingLog';
import { useDOA } from './useDOA';
import { useStudyLog } from './useStudyLog';
import ConfirmationVisitList from './IMVConfirmationLetter/ConfirmationList';
import FollowUp from './IMVFollowupLetter/FollowupLetterList';
import { useSiteContactInfo } from '../steps/useSitecontactinfo';
import { archLevel } from 'src/data/config';
import DataGridEMREvaluation from './EMREvaluation/DataGridEMREvaluation';
import DataGridNoteToFile from './NoteToFile/DataGridNoteToFile';
import { SIVFollowupTable } from './SiteInitiationFollowupLetter/SIVFollowupTable';
import DataGridSQConfirmationLetter from './sqConfirmationLetter/DataGridSQConfirmationLetter';
import DataGridSQFollowUpLetter from './sqFollowupLetter/DataGridSQFollowUpLetter';
import DataGridSIVConfirmationLetter from './SIVConfirmationLetter/DataGridSIVConfirmationLetter';
import MonitoringVisit from './MonitoringVisitLogs/MonitoringVisit';
import { DataTable } from '@pihealth/common-ui-library';
import { useUtil } from 'src/components/hooks/useUtil';
import { useFrom1572 } from './Form1572/useForm1572';

const StudyLogs1: React.FunctionComponent<any> = () => {
  const { selectedApp, selectedAppSection } = useSelectedAppInfo();
  const [pageSize, setPageSize] = React.useState(10);
  const { studyLogs } = useFieldTranslation();
  const [studyLogOpen, setStudyLogOpen] = useState(true);
  const [issuesOn, setIssuesOn] = useState(false);
  const [protocolOn, setProtocolOn] = useState(false);
  const [protocolQAOn, setProtocolQAOn] = useState(false);
  const [followUp, setFollowUp] = useState(false);
  const [confirmation, setconfirmation] = useState(false);
  const [noteTofileOpen, setNoteToFileOpen] = useState<boolean>(false);

  const [gridRowsCount, setGridRowsCount] = React.useState(0);
  const [gridRows, setGridRows] = useState<any[]>([]);
  const startupLogsOrder = [
    studyLogs.label1,
    studyLogs.label2,
    studyLogs.label3,
    studyLogs.label4,
    studyLogs.label5,
    studyLogs.label7,
    studyLogs.label11,
    studyLogs.label12,
    studyLogs.label13,
    studyLogs.label14,
    studyLogs.label6,
    studyLogs.label8,
    studyLogs.label15
  ];
  const conductLogsOrder = [
    studyLogs.label6,
    studyLogs.label7,
    studyLogs.label8,
    studyLogs.label4,
    studyLogs.label9,
    studyLogs.label10,
    studyLogs.label5
  ];
  const { getForm1572QueryData, form1572QueryData } = useFrom1572();

  useEffect(() => {
    getForm1572QueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      application_module_section: 'STUDY LOGS'
    });
  }, []);
  useEffect(() => {
    if (form1572QueryData) {
      setUpdated1572Version(form1572QueryData.form_1572.ffst_version);
      setForm1572EtmfDocumentMetaId(form1572QueryData.form_1572.tp_document_meta_id);
      setForm1572EtmfTmfDocumentId(form1572QueryData.form_1572.tp_document_id);
      setIsForm1572VersionClickable(
        form1572QueryData.form_1572.ffst_version > 1 || form1572QueryData.form_1572.ffst_publish_isf === 'Y'
      );
    }
  }, [form1572QueryData]);

  archLevel === 'site' ? conductLogsOrder.push(studyLogs.label16) : startupLogsOrder.push(studyLogs.label16);
  const dispatch = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();
  const { preferedDateFormat, userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const { getCommonStudyLogs, commonStudyLogsIsLoading } = useStudyLog();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const currentHierarchyLevel = useAppSelector(state => state.site.currentHierarchyLevel);
  const siteData = useAppSelector(state => state.site.siteInfo);
  const [doaOpen, setDOAOpen] = useState(false);
  const { doaLinkQueryData, getDOALinkQueryData } = useDOA();
  const [isForm1572VersionClickable, setIsForm1572VersionClickable] = useState(false);
  const [open1572VersoinHistory, setOpen1572VersoinHistory] = useState(false);
  const [form1572EtmfDocumentMetaId, setForm1572EtmfDocumentMetaId] = useState('');
  const [form1572EtmfTmfDocumentId, setForm1572EtmfTmfDocumentId] = useState('');
  const [openDOAVersoinHistory, setOpenDOAVersoinHistory] = useState(false);
  const [doaDocumentId, setDoaDocumentId] = useState('');
  const [doaMasterId, setDoaMasterId] = useState('');
  const [updated1572Version, setUpdated1572Version] = useState(1);

  const [trainingOpen, setTrainingOpen] = useState(false);
  const [form1572Open, setForm1572Open] = useState(false);
  const [dragAccount, setDragAccount] = useState(false);
  const [monitoringVisitOpen, setMonitoringVisitOpen] = useState(false);

  const [sqConfirmLetterOpen, setSqConfirmLetterOpen] = useState(false);
  const [sqFollowupLetterOpen, setSqFollowupLetterOpen] = useState(false);
  const [sivConfirmLetterOpen, setSIVConfirmLetterOpen] = useState(false);
  const [sivFollowupLetterOpen, setSIVFollowupLetterOpen] = useState(false);
  const [emrEvaluationOpen, setEMREvaluationOpen] = useState(false);
  const [siteStudyData, setSiteStudyData] = useState({} as any);
  const { data: personelRoleData } = useGetCodeListDataQuery('STPRROL');
  const { handleError } = useUtil();
  const { getSiteStudyPersonnelQueryData, siteStudyPersonnelQueryData, siteTsdaStudyPersonnelQueryData } =
    useSiteContactInfo();
  const callGetSiteStudyPersonnelsData = async () => {
    await getSiteStudyPersonnelQueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: `${archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP}`
    });
  };

  const getCommonStudyLogsData = async () => {
    setGridRows([]);
    let tempGridRows: any[] = [];
    const studyLogsResponse: any = await getCommonStudyLogs({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application_section: selectedAppSection
    });
    const filtered = siteData?.study?.non_interventional;
    if (studyLogsResponse?.data) {
      if (studyLogOpen && selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG) {
        tempGridRows = getConductStudyLogList(studyLogsResponse);
      } else if (studyLogOpen && selectedApp === process.env.REACT_APP_CTMS_SLUG && currentHierarchyLevel === 'site') {
        tempGridRows = getStartupStudyLogList(studyLogsResponse);
      }
    }
    if (studyLogsResponse?.error) {
      handleError(studyLogsResponse.error);
      if (studyLogsResponse.error.status !== 404) {
        return;
      }
      if (studyLogOpen && selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG) {
        const logLabels: string[] = [];
        conductLogsOrder.map((logName: string) => {
          if (studyLogs.label4 === logName && checkPermission('view_conduct_monitoring_visit')) {
            logLabels.push(logName);
          }
          if (
            studyLogs.label6 === logName &&
            (checkPermission('view_sponsor_issue') || checkPermission('view_site_issue'))
          ) {
            logLabels.push(logName);
          }
          if (
            studyLogs.label7 === logName &&
            (checkPermission('view_site_protocoldeviation') || checkPermission('view_sponsor_protocoldeviation'))
          ) {
            logLabels.push(logName);
          }
          if (
            studyLogs.label8 === logName &&
            (checkPermission('view_sponsor_protocol_qa') || checkPermission('view_site_protocol_qa'))
          ) {
            logLabels.push(logName);
          }
          if (studyLogs.label9 === logName && checkPermission('view_imv_confirmationletter')) {
            logLabels.push(logName);
          }
          if (studyLogs.label10 === logName && checkPermission('view_imv_followupletter')) {
            logLabels.push(logName);
          }
          if (studyLogs.label5 === logName && checkPermission('view_drug_accountability_record') && filtered !== true) {
            logLabels.push(logName);
          }
          if (studyLogs.label16 === logName && checkPermission('view_site_note_to_file_studylogs')) {
            logLabels.push(logName);
          }
        });
        logLabels?.map((log: string, index: number) => {
          tempGridRows.push({
            id: index,
            log,
            initial_entry_by: '-',
            modified_by: '-',
            last_modified: '-',
            version: '1.0'
          });
        });
      } else if (studyLogOpen && selectedApp === process.env.REACT_APP_CTMS_SLUG) {
        const logLabels: string[] = [];
        startupLogsOrder.map((logName: string, index: number) => {
          if (studyLogs.label1 === logName && checkPermission('view_site_doa')) {
            logLabels.push(logName);
          }
          if (studyLogs.label2 === logName && checkPermission('view_site_siv_training')) {
            logLabels.push(logName);
          }
          if (studyLogs.label3 === logName && checkPermission('view_1572_form')) {
            logLabels.push(logName);
          }
          if (studyLogs.label4 === logName && checkPermission('view_strtup_monitoring_visit')) {
            logLabels.push(logName);
          }
          if (studyLogs.label5 === logName && checkPermission('view_drug_accountability_record') && filtered !== true) {
            logLabels.push(logName);
          }
          if (studyLogs.label11 === logName && checkPermission('view_sitequalifi_confirmationletter')) {
            logLabels.push(logName);
          }
          if (studyLogs.label12 === logName && checkPermission('view_sitequalifi_followupletter')) {
            logLabels.push(logName);
          }
          if (studyLogs.label13 === logName && checkPermission('view_si_confirmationletter')) {
            logLabels.push(logName);
          }
          if (studyLogs.label14 === logName && checkPermission('view_si_followupletter')) {
            logLabels.push(logName);
          }
          if (
            studyLogs.label6 === logName &&
            (checkPermission('view_sponsor_issue') || checkPermission('view_site_issue'))
          ) {
            logLabels.push(logName);
          }
          if (archLevel == 'site') {
            if (
              studyLogs.label8 === logName &&
              (checkPermission('view_sponsor_protocol_qa') || checkPermission('view_site_protocol_qa'))
            ) {
              logLabels.push(logName);
            }
          }
          if (studyLogs.label15 === logName && checkPermission('view_emr_evalaution_studylogs')) {
            logLabels.push(logName);
          }
          if (studyLogs.label16 === logName && checkPermission('view_sponsor_note_to_file_studylogs')) {
            logLabels.push(logName);
          }
        });
        logLabels?.map((log: string, index: number) => {
          tempGridRows.push({
            id: index,
            log,
            initial_entry_by: '-',
            modified_by: '-',
            last_modified: '-',
            version: '1.0'
          });
        });
      }
    }
    setGridRows(tempGridRows);
    setGridRowsCount(tempGridRows.length);
  };
  // setting the conuct study logs list for data grid
  const getConductStudyLogList = (studyLogsResponse: any) => {
    const constructRows: any = [];
    const logLabels: string[] = [];
    const filtered = siteData?.study?.non_interventional;
    conductLogsOrder.map((logName: string) => {
      if (studyLogs.label4 === logName && checkPermission('view_conduct_monitoring_visit')) {
        logLabels.push(logName);
      }
      if (
        studyLogs.label6 === logName &&
        (checkPermission('view_sponsor_issue') || checkPermission('view_site_issue'))
      ) {
        logLabels.push(logName);
      }
      if (
        studyLogs.label7 === logName &&
        (checkPermission('view_site_protocoldeviation') || checkPermission('view_sponsor_protocoldeviation'))
      ) {
        logLabels.push(logName);
      }
      if (
        studyLogs.label8 === logName &&
        (checkPermission('view_sponsor_protocol_qa') || checkPermission('view_site_protocol_qa'))
      ) {
        logLabels.push(logName);
      }
      if (studyLogs.label9 === logName && checkPermission('view_imv_confirmationletter')) {
        logLabels.push(logName);
      }
      if (studyLogs.label10 === logName && checkPermission('view_imv_followupletter')) {
        logLabels.push(logName);
      }
      if (studyLogs.label5 === logName && checkPermission('view_drug_accountability_record') && filtered !== true) {
        logLabels.push(logName);
      }
      if (studyLogs.label16 === logName && checkPermission('view_site_note_to_file_studylogs')) {
        logLabels.push(logName);
      }
    });
    logLabels.map((logName: string, index: number) => {
      const logData = studyLogsResponse?.data?.selected_data.find((data: any) => {
        return data.log === logName;
      });
      constructRows.push({
        id: index,
        log: logName,
        initial_entry_by: logData && logData?.initial_entry_by !== null ? logData?.initial_entry_by : '-',
        modified_by: logData && logData?.modified_by !== null ? logData?.modified_by : '-',
        last_modified:
          logData && logData?.last_modified !== null ? getPreferredDateTimeInLocal(logData?.last_modified) : '-',
        version: '1.0'
      });
    });
    return constructRows;
  };

  // setting the startup study logs list for grid
  const getStartupStudyLogList = (studyLogsResponse: any) => {
    const constructRows: any = [];
    const logLabels: string[] = [];
    const filtered = siteData?.study?.non_interventional;
    startupLogsOrder.map((logName: string) => {
      if (studyLogs.label1 === logName && checkPermission('view_site_doa')) {
        logLabels.push(logName);
      }
      if (studyLogs.label2 === logName && checkPermission('view_site_siv_training')) {
        logLabels.push(logName);
      }
      if (studyLogs.label3 === logName && checkPermission('view_1572_form')) {
        logLabels.push(logName);
      }
      if (studyLogs.label4 === logName && checkPermission('view_strtup_monitoring_visit')) {
        logLabels.push(logName);
      }
      if (studyLogs.label5 === logName && checkPermission('view_drug_accountability_record') && filtered !== true) {
        logLabels.push(logName);
      }
      if (studyLogs.label11 === logName && checkPermission('view_sitequalifi_confirmationletter')) {
        logLabels.push(logName);
      }
      if (studyLogs.label12 === logName && checkPermission('view_sitequalifi_followupletter')) {
        logLabels.push(logName);
      }
      if (studyLogs.label13 === logName && checkPermission('view_si_confirmationletter')) {
        logLabels.push(logName);
      }
      if (studyLogs.label14 === logName && checkPermission('view_si_followupletter')) {
        logLabels.push(logName);
      }
      if (
        studyLogs.label6 === logName &&
        (checkPermission('view_sponsor_issue') || checkPermission('view_site_issue'))
      ) {
        logLabels.push(logName);
      }
      if (archLevel == 'site') {
        if (
          studyLogs.label8 === logName &&
          (checkPermission('view_sponsor_protocol_qa') || checkPermission('view_site_protocol_qa'))
        ) {
          logLabels.push(logName);
        }
      }
      if (studyLogs.label15 === logName && checkPermission('view_emr_evalaution_studylogs')) {
        logLabels.push(logName);
      }
      if (studyLogs.label16 === logName && checkPermission('view_sponsor_note_to_file_studylogs')) {
        logLabels.push(logName);
      }
    });
    logLabels.map((logName: string, index: number) => {
      const logData = studyLogsResponse?.data?.selected_data.find((data: any) => {
        return data.log_name === logName;
      });
      constructRows.push({
        id: index,
        log: logName,
        initial_entry_by: logData && logData?.created_by !== null ? logData?.created_by : '-',
        modified_by: logData && logData?.modified_by !== null ? logData?.modified_by : '-',
        last_modified:
          logData && logData?.last_modified !== null ? getPreferredDateTimeInLocal(logData?.last_modified) : '-',
        version: '1.0'
      });
    });
    return constructRows;
  };

  useEffect(() => {
    if (doaLinkQueryData) {
      // getDOALinkQueryData({
      //   site_id: selectedSite,
      //   study_id: studyId,
      //   country: selectedCountry,
      //   application: process.env.REACT_APP_NAME
      // });
      setDoaMasterId(doaLinkQueryData && doaLinkQueryData.StudyLogs[0].Personnel[0].tp_document_meta_id);
      setDoaDocumentId(doaLinkQueryData && doaLinkQueryData.StudyLogs[0].Personnel[0].tp_document_id);
    }
  }, [doaLinkQueryData]);
  useEffect(() => {
    callGetSiteStudyPersonnelsData();
    if (studyLogOpen && selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG) {
      getCommonStudyLogsData();
      // if (checkPermission('view_imv_confirmationletter')) {
      //   checkPermission('view_published_imvconfletter')
      //     ? getPublishConfirmationVisitData({
      //         site_id: selectedSite,
      //         study_id: studyId,
      //         application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG,
      //         country: selectedCountry
      //       })
      //     : getConfirmationVisitData({
      //         site_id: selectedSite,
      //         study_id: studyId,
      //         application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG,
      //         country: selectedCountry
      //       });
      // }
    } else if (studyLogOpen && selectedApp === process.env.REACT_APP_CTMS_SLUG && currentHierarchyLevel === 'site') {
      getCommonStudyLogsData();
      if (checkPermission('view_1572_form')) {
        // getForm1572Data();
        if (fromNavigationPathName === 'SitePersonal' || fromNavigationPathName === 'Summary-StudyLogs-1572') {
          handleStudyLogChange(studyLogs.label3);
        }
      }
      if (checkPermission('view_site_doa')) {
        getDOALinkQueryData({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
        if (fromNavigationPathName === 'DOA' || fromNavigationPathName === 'Summary-StudyLogs-DOA') {
          handleStudyLogChange(studyLogs.label1);
        }
      }
      if (checkPermission('view_site_siv_training')) {
        if (fromNavigationPathName === 'SIVTL' || fromNavigationPathName === 'Summary-StudyLogs-TrainingLog') {
          handleStudyLogChange(studyLogs.label2);
        }
      }
      if (checkPermission('view_strtup_monitoring_visit')) {
        if (fromNavigationPathName === 'MSVL') {
          handleStudyLogChange(studyLogs.label4);
        }
      }
      dispatch(setPath(''));
    }
  }, [studyLogOpen, currentHierarchyLevel, studyId, selectedSite, selectedCountry, form1572QueryData]);

  useEffect(() => {
    if (siteStudyPersonnelQueryData) {
      setSiteStudyData({
        ...siteStudyPersonnelQueryData.site,
        ...siteStudyPersonnelQueryData.study
      });
    }
    if (siteTsdaStudyPersonnelQueryData) {
      setSiteStudyData({
        ...siteTsdaStudyPersonnelQueryData.site,
        ...siteTsdaStudyPersonnelQueryData.study
      });
    }
  }, [siteStudyPersonnelQueryData, siteTsdaStudyPersonnelQueryData]);

  const fromNavigationPathName: any = useAppSelector(state => {
    return state.navigationPath.navigationPathName;
  });

  const formatDate = (params: any) => {
    return preferedDateFormat(params.value);
  };

  const handleStudyLogChange = (log: any) => {
    if (selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG) {
      if (log === studyLogs.label4 && checkPermission('view_conduct_monitoring_visit')) {
        setStudyLogOpen(false);
        setProtocolOn(false);
        setProtocolQAOn(false);
        setIssuesOn(false);
        setMonitoringVisitOpen(true);
      } else if (
        log === studyLogs.label6 &&
        (checkPermission('view_sponsor_issue') || checkPermission('view_site_issue'))
      ) {
        setStudyLogOpen(false);
        setProtocolOn(false);
        setProtocolQAOn(false);
        setIssuesOn(true);
      } else if (
        log === studyLogs.label7 &&
        (checkPermission('view_sponsor_protocoldeviation') || checkPermission('view_site_protocoldeviation'))
      ) {
        setStudyLogOpen(false);
        setIssuesOn(false);
        setProtocolQAOn(false);
        setProtocolOn(true);
      } else if (
        log === studyLogs.label8 &&
        (checkPermission('view_sponsor_protocol_qa') || checkPermission('view_site_protocol_qa'))
      ) {
        setStudyLogOpen(false);
        setIssuesOn(false);
        setProtocolOn(false);
        setProtocolQAOn(true);
      } else if (log === studyLogs.label9 && checkPermission('view_imv_confirmationletter')) {
        setStudyLogOpen(false);
        setIssuesOn(false);
        setProtocolOn(false);
        setProtocolQAOn(false);
        setconfirmation(true);
      } else if (log === studyLogs.label10 && checkPermission('view_imv_followupletter')) {
        setStudyLogOpen(false);
        setIssuesOn(false);
        setProtocolOn(false);
        setProtocolQAOn(false);
        setFollowUp(true);
      } else if (log === studyLogs.label5 && checkPermission('view_drug_accountability_record')) {
        setStudyLogOpen(false);
        setIssuesOn(false);
        setProtocolOn(false);
        setProtocolQAOn(false);
        setFollowUp(false);
        setDragAccount(true);
      } else if (log === studyLogs.label16 && checkPermission('view_site_note_to_file_studylogs')) {
        setStudyLogOpen(false);
        setIssuesOn(false);
        setProtocolOn(false);
        setProtocolQAOn(false);
        setFollowUp(false);
        setDragAccount(false);
        setNoteToFileOpen(true);
      }
    } else if (selectedApp === process.env.REACT_APP_CTMS_SLUG) {
      if (log === studyLogs.label1 && checkPermission('view_site_doa')) {
        setStudyLogOpen(false);
        setTrainingOpen(false);
        setDragAccount(false);
        setDOAOpen(true);
        setSqConfirmLetterOpen(false);
        setSqFollowupLetterOpen(false);
        setSIVConfirmLetterOpen(false);
        setSIVFollowupLetterOpen(false);
        setEMREvaluationOpen(false);
        setMonitoringVisitOpen(false);
        setProtocolQAOn(false);
        setIssuesOn(false);
        setProtocolOn(false);
      } else if (
        log === studyLogs.label6 &&
        (checkPermission('view_sponsor_issue') || checkPermission('view_site_issue'))
      ) {
        setStudyLogOpen(false);
        setTrainingOpen(false);
        setDragAccount(false);
        setDOAOpen(false);
        setSqConfirmLetterOpen(false);
        setSqFollowupLetterOpen(false);
        setSIVConfirmLetterOpen(false);
        setSIVFollowupLetterOpen(false);
        setEMREvaluationOpen(false);
        setMonitoringVisitOpen(false);
        setStudyLogOpen(false);
        setProtocolQAOn(false);
        setIssuesOn(true);
        setProtocolOn(false);
      } else if (
        log === studyLogs.label7 &&
        (checkPermission('view_site_protocoldeviation') || checkPermission('view_sponsor_protocoldeviation'))
      ) {
        setStudyLogOpen(false);
        setTrainingOpen(false);
        setDragAccount(false);
        setDOAOpen(false);
        setSqConfirmLetterOpen(false);
        setSqFollowupLetterOpen(false);
        setSIVConfirmLetterOpen(false);
        setSIVFollowupLetterOpen(false);
        setEMREvaluationOpen(false);
        setMonitoringVisitOpen(false);
        setStudyLogOpen(false);
        setProtocolQAOn(false);
        setIssuesOn(false);
        setProtocolOn(true);
      } else if (
        log === studyLogs.label8 &&
        (checkPermission('view_sponsor_protocol_qa') || checkPermission('view_site_protocol_qa'))
      ) {
        setStudyLogOpen(false);
        setTrainingOpen(false);
        setDragAccount(false);
        setDOAOpen(false);
        setSqConfirmLetterOpen(false);
        setSqFollowupLetterOpen(false);
        setSIVConfirmLetterOpen(false);
        setSIVFollowupLetterOpen(false);
        setMonitoringVisitOpen(false);
        setEMREvaluationOpen(false);
        setStudyLogOpen(false);
        setProtocolQAOn(true);
        setIssuesOn(false);
        setProtocolOn(false);
      } else if (log === studyLogs.label2 && checkPermission('view_site_siv_training')) {
        setStudyLogOpen(false);
        setDOAOpen(false);
        setDragAccount(false);
        setTrainingOpen(true);
        setSqConfirmLetterOpen(false);
        setSqFollowupLetterOpen(false);
        setSIVConfirmLetterOpen(false);
        setSIVFollowupLetterOpen(false);
        setEMREvaluationOpen(false);
        setMonitoringVisitOpen(false);
        setProtocolQAOn(false);
        setIssuesOn(false);
        setProtocolOn(false);
      } else if (log === studyLogs.label3 && checkPermission('view_1572_form')) {
        setStudyLogOpen(false);
        setDOAOpen(false);
        setTrainingOpen(false);
        setDragAccount(false);
        setForm1572Open(true);
        setSqConfirmLetterOpen(false);
        setSqFollowupLetterOpen(false);
        setSIVConfirmLetterOpen(false);
        setSIVFollowupLetterOpen(false);
        setEMREvaluationOpen(false);
        setMonitoringVisitOpen(false);
        setProtocolQAOn(false);
        setIssuesOn(false);
        setProtocolOn(false);
      } else if (log === studyLogs.label4 && checkPermission('view_strtup_monitoring_visit')) {
        setStudyLogOpen(false);
        setDOAOpen(false);
        setTrainingOpen(false);
        setForm1572Open(false);
        setDragAccount(false);
        setMonitoringVisitOpen(true);
        setSqConfirmLetterOpen(false);
        setSqFollowupLetterOpen(false);
        setSIVConfirmLetterOpen(false);
        setProtocolQAOn(false);
        setIssuesOn(false);
        setProtocolOn(false);
      } else if (log === studyLogs.label5 && checkPermission('view_drug_accountability_record')) {
        setMonitoringVisitOpen(false);
        setStudyLogOpen(false);
        setDOAOpen(false);
        setTrainingOpen(false);
        setForm1572Open(false);
        setDragAccount(true);
        setSqConfirmLetterOpen(false);
        setSqFollowupLetterOpen(false);
        setSIVConfirmLetterOpen(false);
        setSIVFollowupLetterOpen(false);
        setEMREvaluationOpen(false);
        setProtocolQAOn(false);
        setIssuesOn(false);
        setProtocolOn(false);
      } else if (log === studyLogs.label11 && checkPermission('view_sq_confirmationletter')) {
        if (archLevel === 'sponsor') {
          setStudyLogOpen(false);
          setDOAOpen(false);
          setTrainingOpen(false);
          setForm1572Open(false);
          setDragAccount(false);
          setSqConfirmLetterOpen(true);
          setSqFollowupLetterOpen(false);
          setSIVConfirmLetterOpen(false);
          setSIVFollowupLetterOpen(false);
          setEMREvaluationOpen(false);
          setProtocolQAOn(false);
          setIssuesOn(false);
          setProtocolOn(false);
        } else {
          if (archLevel === 'site' && checkPermission('publishview_siqualifi_confirmationletter')) {
            setStudyLogOpen(false);
            setDOAOpen(false);
            setTrainingOpen(false);
            setForm1572Open(false);
            setDragAccount(false);
            setSqConfirmLetterOpen(true);
            setSqFollowupLetterOpen(false);
            setSIVConfirmLetterOpen(false);
            setSIVFollowupLetterOpen(false);
            setEMREvaluationOpen(false);
            setProtocolQAOn(false);
            setIssuesOn(false);
            setProtocolOn(false);
          } else {
            dispatch(
              setMessage({
                msgDetails: 'Letter is not Published',
                severity: 'error'
              })
            );
          }
        }
      } else if (log === studyLogs.label12 && checkPermission('view_sq_followupletter')) {
        if (archLevel === 'sponsor') {
          setStudyLogOpen(false);
          setDOAOpen(false);
          setTrainingOpen(false);
          setForm1572Open(false);
          setDragAccount(false);
          setSqConfirmLetterOpen(false);
          setSqFollowupLetterOpen(true);
          setSIVConfirmLetterOpen(false);
          setSIVFollowupLetterOpen(false);
          setEMREvaluationOpen(false);
          setProtocolOn(false);
        } else {
          if (archLevel === 'site' && checkPermission('publishview_siqualifi_followupletter')) {
            setStudyLogOpen(false);
            setDOAOpen(false);
            setTrainingOpen(false);
            setForm1572Open(false);
            setDragAccount(false);
            setSqConfirmLetterOpen(false);
            setSqFollowupLetterOpen(true);
            setSIVConfirmLetterOpen(false);
            setSIVFollowupLetterOpen(false);
            setEMREvaluationOpen(false);
            setProtocolOn(false);
          }
        }
      } else if (log === studyLogs.label13 && checkPermission('view_si_confirmationletter')) {
        if (archLevel === 'sponsor') {
          setStudyLogOpen(false);
          setDOAOpen(false);
          setTrainingOpen(false);
          setForm1572Open(false);
          setDragAccount(false);
          setSqConfirmLetterOpen(false);
          setSqFollowupLetterOpen(false);
          setSIVConfirmLetterOpen(true);
          setSIVFollowupLetterOpen(false);
          setProtocolOn(false);
        } else {
          if (archLevel === 'site' && checkPermission('latest_publish_siv_confirmationletter')) {
            setStudyLogOpen(false);
            setDOAOpen(false);
            setTrainingOpen(false);
            setForm1572Open(false);
            setDragAccount(false);
            setSqConfirmLetterOpen(false);
            setSqFollowupLetterOpen(false);
            setSIVConfirmLetterOpen(true);
            setSIVFollowupLetterOpen(false);
            setProtocolOn(false);
          }
        }
      } else if (log === studyLogs.label14 && checkPermission('view_si_followupletter')) {
        if (archLevel === 'sponsor') {
          setStudyLogOpen(false);
          setDOAOpen(false);
          setTrainingOpen(false);
          setForm1572Open(false);
          setDragAccount(false);
          setSqConfirmLetterOpen(false);
          setSqFollowupLetterOpen(false);
          setSIVConfirmLetterOpen(false);
          setSIVFollowupLetterOpen(true);
          setProtocolOn(false);
        } else {
          if (archLevel === 'site' && checkPermission('latest_publish_siv_followupletter')) {
            setStudyLogOpen(false);
            setDOAOpen(false);
            setTrainingOpen(false);
            setForm1572Open(false);
            setDragAccount(false);
            setSqConfirmLetterOpen(false);
            setSqFollowupLetterOpen(false);
            setSIVConfirmLetterOpen(false);
            setSIVFollowupLetterOpen(true);
            setProtocolOn(false);
          }
        }
      } else if (log === studyLogs.label15 && checkPermission('view_emr_evalaution_studylogs')) {
        setStudyLogOpen(false);
        setDOAOpen(false);
        setTrainingOpen(false);
        setForm1572Open(false);
        setDragAccount(false);
        setSqConfirmLetterOpen(false);
        setSqFollowupLetterOpen(false);
        setSIVConfirmLetterOpen(false);
        setSIVFollowupLetterOpen(false);
        setEMREvaluationOpen(true);
        setProtocolOn(false);
      } else if (
        log === studyLogs.label16 && archLevel === 'site'
          ? checkPermission('view_site_note_to_file_studylogs')
          : checkPermission('view_sponsor_note_to_file_studylogs')
      ) {
        setStudyLogOpen(false);
        setDOAOpen(false);
        setTrainingOpen(false);
        setForm1572Open(false);
        setDragAccount(false);
        setSqConfirmLetterOpen(false);
        setSqFollowupLetterOpen(false);
        setSIVConfirmLetterOpen(false);
        setSIVFollowupLetterOpen(false);
        setEMREvaluationOpen(false);
        setProtocolOn(false);
        setNoteToFileOpen(true);
      }
    }
  };

  const logVersions = (row: any) => {
    let retunVal: any;
    const doaVersion = doaLinkQueryData && doaLinkQueryData.StudyLogs[0].Personnel[0].doa_publish_version;
    switch (row.log) {
      case studyLogs.label1:
        retunVal =
          doaVersion !== 0.0 ? (
            <Link onClick={field => handleDoaVersionHistory()}>
              {doaVersion === 1
                ? doaVersion.toFixed(1)
                : Number(doaVersion) > 0.9
                ? Number(doaVersion).toFixed(1)
                : doaVersion}
            </Link>
          ) : (
            '1.0'
          );
        break;
      case studyLogs.label3:
        retunVal = isForm1572VersionClickable ? (
          <Link onClick={field => handleVersionHistory()}>{updated1572Version.toFixed(1)}</Link>
        ) : (
          updated1572Version.toFixed(1)
        );
        break;
      default:
        retunVal = row.version;
    }
    return retunVal;
  };

  const handleVersionHistory = async () => {
    setOpen1572VersoinHistory(true);
  };
  const handleDoaVersionHistory = async () => {
    setOpenDOAVersoinHistory(true);
  };
  const columns = [
    {
      field: 'log',
      headerName: studyLogs.field_headerName1,
      minWidth: 240,
      flex: 1,
      renderCell: (params: any) => (
        <Link onClick={field => handleStudyLogChange(params.row.log)}>{params.value?.toString()}</Link>
      )
    },
    {
      field: 'initial_entry_by',
      headerName: studyLogs.field_headerName2,
      width: 160
    },
    {
      field: 'modified_by',
      headerName: studyLogs.field_headerName3,
      width: 160
    },
    {
      field: 'last_modified',
      headerName: studyLogs.field_headerName4,
      width: 200,
      type: 'date',
      valueGetter: formatDate
    },
    {
      field: 'version',
      headerName: studyLogs.field_headerName5,
      width: 80,
      renderCell: (params: any) => logVersions(params.row),
      valueGetter: (params: any) => logVersions(params.row)
    }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [openUploadDocument, setOpenUploadDocument] = useState(false);
  const dataTableProps = {
    sx: {
      '& .MuiDataGrid-columnHeaderTitle': {
        whiteSpace: 'break-spaces !important',
        lineHeight: 1.3,
        '&:hover': {
          textOverflow: 'ellipsis'
        }
      },
      '& .MuiDataGrid-cell': {
        whiteSpace: 'normal !important',
        lineHeight: 'normal'
      }
    }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fields: exportFields,
          fileName: `Study Logs ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
        printOptions={{ fields: exportFields }}
      />
    );
  };
  return (
    <>
      {studyLogOpen ? (
        <div style={{ height: '82vh', width: '100%' }}>
          <div style={{ display: 'flex', height: '100%' }}>
            <div className="mydata-grid-row" style={{ flexGrow: 1 }}>
              <DataTable
                height={'82vh'}
                dataTableProps={dataTableProps}
                hasDefinedColumns
                columns={columns}
                className={
                  selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG ? 'studylogDatagrid' : 'studylog-datagrid'
                }
                rows={gridRows}
                rowCount={gridRowsCount}
                pagination
                pageSize={pageSize}
                setPageSize={setPageSize}
                loading={commonStudyLogsIsLoading}
                hasDefinedDataGridToolbarExport
                definedGridToolbarExport={definedCustomDatGridExport}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          {issuesOn ? <Issues setStudyLogOpen={setStudyLogOpen} setIssuesOn={setIssuesOn} /> : <></>}
          {protocolOn ? <ProtocolDeviations setStudyLogOpen={setStudyLogOpen} setProtocolOn={setProtocolOn} /> : <></>}
          {protocolQAOn ? <ProtocolQA setStudyLogOpen={setStudyLogOpen} setProtocolQAOn={setProtocolQAOn} /> : <></>}
          {followUp ? <FollowUp setStudyLogOpen={setStudyLogOpen} setFollowUp={setFollowUp} /> : <></>}
          {confirmation ? (
            <ConfirmationVisitList setStudyLogOpen={setStudyLogOpen} setProtocolQAOn={setconfirmation} />
          ) : (
            <></>
          )}
          {doaOpen ? (
            <DeligationOfAuth
              setStudyLogOpen={setStudyLogOpen}
              setDOAOpen={setDOAOpen}
              setForm1572Open={setForm1572Open}
              personelRoleData={
                personelRoleData
                  ?.map((ele: any) => {
                    return {
                      name: ele.code_list_value,
                      id: ele.code_list_value
                    };
                  })
                  .filter((ele: any) => ele.name != 'Sponsor Read Only') ?? []
              }
            />
          ) : (
            <></>
          )}
          {trainingOpen ? (
            <TrainingLog
              openUploadDocument={openUploadDocument}
              setOpenUploadDocument={setOpenUploadDocument}
              setStudyLogOpen={setStudyLogOpen}
              setTrainingOpen={setTrainingOpen}
              setForm1572Open={setForm1572Open}
            />
          ) : (
            <></>
          )}
          {form1572Open ? (
            <Form1572
              setStudyLogOpen={setStudyLogOpen}
              setDOAOpen={setDOAOpen}
              setForm1572Open={setForm1572Open}
              setIsForm1572VersionClickable={setIsForm1572VersionClickable}
              setUpdated1572Version={setUpdated1572Version}
              setForm1572EtmfDocumentMetaId={setForm1572EtmfDocumentMetaId}
              setForm1572EtmfTmfDocumentId={setForm1572EtmfTmfDocumentId}
            />
          ) : (
            <></>
          )}
          {dragAccount ? (
            <DrugAccountability setStudyLogOpen={setStudyLogOpen} setDragAccount={setDragAccount} />
          ) : (
            <></>
          )}
          {monitoringVisitOpen ? (
            <MonitoringVisit setStudyLogOpen={setStudyLogOpen} setMonitoringVisitOpen={setMonitoringVisitOpen} />
          ) : (
            <></>
          )}
          {sqConfirmLetterOpen ? (
            <DataGridSQConfirmationLetter
              siteStudyData={siteStudyData}
              setSqConfirmLetterOpen={setSqConfirmLetterOpen}
              setStudyLogOpen={setStudyLogOpen}
              sqConfirmLetterOpen={sqConfirmLetterOpen}
            />
          ) : (
            <></>
          )}
          {sqFollowupLetterOpen ? (
            <DataGridSQFollowUpLetter
              siteStudyData={siteStudyData}
              setSqFollowupLetterOpen={setSqFollowupLetterOpen}
              setStudyLogOpen={setStudyLogOpen}
            />
          ) : (
            <></>
          )}
          {sivConfirmLetterOpen ? (
            <DataGridSIVConfirmationLetter
              siteStudyPersonnelsData={siteStudyPersonnelQueryData}
              setSIVConfirmLetterOpen={setSIVConfirmLetterOpen}
              setStudyLogOpen={setStudyLogOpen}
            />
          ) : (
            <></>
          )}
          {sivFollowupLetterOpen ? (
            <SIVFollowupTable
              siteStudyPersonnelsData={siteStudyPersonnelQueryData}
              setSIVFollowupLetterOpen={setSIVFollowupLetterOpen}
              setStudyLogOpen={setStudyLogOpen}
            />
          ) : (
            <></>
          )}
          {emrEvaluationOpen ? (
            <DataGridEMREvaluation
              siteStudyPersonnelsData={siteStudyPersonnelQueryData}
              EMREvaluationData={{}}
              setEMREvaluationOpen={setEMREvaluationOpen}
              setStudyLogOpen={setStudyLogOpen}
            />
          ) : (
            <></>
          )}
          {noteTofileOpen ? (
            <DataGridNoteToFile
              siteStudyPersonnelsData={siteStudyPersonnelQueryData}
              EMREvaluationData={{}}
              setNoteToFileOpen={setNoteToFileOpen}
              setStudyLogOpen={setStudyLogOpen}
            />
          ) : (
            <></>
          )}
        </>
      )}
      {open1572VersoinHistory || openDOAVersoinHistory ? (
        <VersionHistory
          open1572VersoinHistory={open1572VersoinHistory}
          setOpen1572VersoinHistory={open1572VersoinHistory ? setOpen1572VersoinHistory : undefined}
          form1572EtmfDocumentMetaId={open1572VersoinHistory ? form1572EtmfDocumentMetaId : undefined}
          form1572EtmfTmfDocumentId={open1572VersoinHistory ? form1572EtmfTmfDocumentId : undefined}
          openDOAVersoinHistory={openDOAVersoinHistory}
          setOpenDOAVersoinHistory={openDOAVersoinHistory ? setOpenDOAVersoinHistory : undefined}
          doaDocumentId={openDOAVersoinHistory ? doaDocumentId : undefined}
          doaMasterId={openDOAVersoinHistory ? doaMasterId : undefined}
        />
      ) : null}
    </>
  );
};
export default StudyLogs1;
